import { useSettingsStore, useAppStore } from '@stores';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { usePatchnotesQuery } from '@http';

export function Patchnotes() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Patchnotes' });
  const { data: patchnotes } = usePatchnotesQuery();
  const { seenPatchnotes, setSeenPatchnotes } = useSettingsStore();
  const { userData } = useAppStore();

  if (!patchnotes?.length) return null;
  if (!userData.tutorials.includes('Hub')) return null;

  const pN = patchnotes.sort((a, b) => b.id - a.id)[0];
  const showPatchnotes = seenPatchnotes < pN.id;

  if (!userData.tutorials.includes('Inv')) return null;

  return (
    <Modal onRequestClose={() => setSeenPatchnotes(pN.id)} isOpen={showPatchnotes} title={t('title')}>
      <div className="p-2 bg-black">
        <p className="my-2 text-gray-400">
          {new Date(pN.date).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })}
        </p>

        <ul className="list-disc list-outside ml-4.5 text-sm">
          {pN.notes.map((note, i) => <li className="my-1" key={i}>{note}</li>)}
        </ul>

        {pN.thanks && (
          <div className="mt-6">
            <p className="text-gray-400 mb-2">{t('thanks')}</p>
            <p className="text-sm">{pN.thanks.map(t => `@${t}`).join(', ')}</p>
          </div>
        )}

        <div className="mt-6 text-gold text-sm">
          <p>{t('info')}</p>
        </div>
      </div>
    </Modal>
  );
}